export default [ 'api', function(api) {
  return {
    connect: (authCode, modelId, endpoint) => {
      return api.post(`${ endpoint }`, {code: authCode, modelId: modelId})
        .then(response => response.data);
    }
  };
} ];


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/services/payment.connect.service.js